import { CircleArrowRight } from 'lucide-react';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import { getPageById } from '@/libs/sanity/client';
import { useMediaQuery } from 'usehooks-ts';
import { MOBILE_SCREEN_SIZE } from '@/utils/constants';

type ModuleConnectWithUsProps = {
  anchor?: string;
  certified?: boolean;
  title?: string;
  ctas?: Array<{
    link?: {
      label?: string;
      type?: string;
      _type?: string;
      internal?: {
        _ref?: string;
        ref?: any;
      };
      external?: string;
    };
  }>;
};

const BecomeOurChannelPartner = ({
  anchor,
  certified,
  title,
  ctas,
}: ModuleConnectWithUsProps) => {
  const cta = ctas[0];
  const ctaLabel = cta?.link?.label;
  const isExternal = cta?.link?.external !== undefined;
  const ctaUrl = cta?.link?.external ?? cta?.link?.internal?._ref;
  const [internalRef, setInternalRef] = useState<string>('#');

  useEffect(() => {
    const fetchData = async () => {
      if (cta?.link?.internal) {
        cta.link.internal.ref = await getPageById(cta.link.internal._ref);
        setInternalRef(cta.link.internal.ref?.metadata?.slug?.current);
      }
    };

    fetchData();
  }, []);

  return (
    <section id={anchor} className="max-w-8xl flex flex-col gap-x-8 lg:mx-auto">
      <div
        className={`flex flex-col items-center justify-center w-full h-[340px] ${
          certified ? 'bg-[#373737] text-white' : ''
        }`}
      >
        <h2 className="text-3xl lg:text-4xl font-normal mb-8 px-16 md:px-0">
          {title?.split(' ').map((word, index) => (
            <span
              key={index}
              className={
                word === 'Channel' || word === 'Partner' || word === 'Certified'
                  ? 'text-[#BF984D]'
                  : certified
                    ? 'text-white'
                    : 'text-gray-700'
              }
            >
              {word}{' '}
            </span>
          )) || 'Contact Us'}
        </h2>
        <Link
          href={isExternal ? ctaUrl : '/' + internalRef}
          target={isExternal ? '_blank' : undefined}
          className="group inline-flex items-center justify-between w-[250px] px-6 py-3 
                                border border-[#BF984D] text-[#BF984D] bg-transparent
                                hover:bg-yellow-50 transition-all duration-300"
        >
          <span className="text-base font-semibold">
            {ctaLabel || 'Contact Us'}
          </span>
          <CircleArrowRight
            className="h-5 w-5 transition-transform 
                                group-hover:translate-x-1"
          />
        </Link>
      </div>
    </section>
  );
};

export default BecomeOurChannelPartner;
